import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-section-referer',
  templateUrl: './content-section-referer.component.html',
  styleUrls: ['./content-section-referer.component.css']
})
export class ContentSectionRefererComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
